module.exports = __webpack_public_path__ + "img/card-h03.c43da60a.jpg";